export enum BulkAccessMode {
	ADD_ONLY = 'ADD_ONLY',
	REPLACE = 'REPLACE'

}
